"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemedComponent = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = require("classnames");
var theme_1 = require("../../theme");
var ThemedComponent = function (_a) {
    var _b = _a.as, Component = _b === void 0 ? 'div' : _b, htmlProps = _a.htmlProps, backgroundColor = _a.backgroundColor, backgroundState = _a.backgroundState, borderColor = _a.borderColor, dataTestId = _a["data-testid"], className = _a.className, children = _a.children, branding = _a.branding;
    var bgColors = (0, theme_1.useBackgroundColors)(branding);
    var bgStateColors = (0, theme_1.useBackgroundStateColors)(branding);
    var borderColors = (0, theme_1.useBorderColors)(branding);
    return ((0, jsx_runtime_1.jsx)(Component, __assign({}, htmlProps, { "data-testid": dataTestId, className: (0, classnames_1.default)(bgColors[backgroundColor], bgStateColors[backgroundState], borderColors[borderColor], className) }, { children: children })));
};
exports.ThemedComponent = ThemedComponent;
